// Meta Pixel — LucroSeguro Site (dataset "LucroSeguro Site", id 1514728123185926).
// Arquivo externo (não inline) porque a CSP do site não usa 'unsafe-inline' em script-src.
//
// [UX Q2, 2026-10-09] Só para quem chega pela LANDING. Navegador com sessão salva (ls_sessao, a mesma
// marca que o <head> usa para cobrir a landing) vai direto para o portal: o Pixel não mede ninguém ali
// (cliente logado não é lead) e custava ~0,5 s de travamento no boot com CPU 4× lenta (TBT 2.406 →
// 1.846 ms sem ele). Sair do portal limpa a marca, e a landing volta a medir normalmente.
(function () {
try { if (localStorage.getItem('ls_sessao') === '1') return; } catch (e) { /* sem storage: segue medindo */ }

!function(f,b,e,v,n,t,s){
  if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
  t=b.createElement(e);t.async=!0;t.src=v;
  s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

fbq('init', '1514728123185926');

// CAPI (server-side, Cloud Function) — espelha o mesmo evento com o mesmo event_id
// pro Meta deduplicar navegador+servidor. Best-effort: nunca trava a página nem
// aparece pro usuário se falhar (ad blocker, offline, etc. — o fbq() do navegador
// já rodou e é suficiente sozinho).
var CAPI_URL = 'https://us-central1-lucroseguro-app.cloudfunctions.net/capiEvent';

function lerCookie(nome) {
  var m = document.cookie.match(new RegExp('(?:^|; )' + nome + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : '';
}

function gerarEventId() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'ev_' + Date.now() + '_' + Math.random().toString(36).slice(2);
}

function dispararEvento(nome) {
  var eventId = gerarEventId();
  fbq('track', nome, {}, { eventID: eventId });
  try {
    fetch(CAPI_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        event_name: nome,
        event_id: eventId,
        event_source_url: location.href,
        fbp: lerCookie('_fbp'),
        fbc: lerCookie('_fbc'),
      }),
    }).catch(function () {});
  } catch (e) { /* best-effort — nunca interrompe a navegação */ }
}

dispararEvento('PageView');

// Evento "Contact": clique em qualquer CTA de WhatsApp (wa.me) da landing/modal.
document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href*="wa.me"]');
  if (link) dispararEvento('Contact');
});
})();
